import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { TournamentsService } from "src/app/services/tournamnet.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { LazyLoadEvent } from "primeng/api";
import { UserService } from '../../../../services/user.service';
import { SubscribeService } from "src/app/frontend/service/subscribeService.service";
@Component({
  selector: "app-contestplayer-details",
  templateUrl: "./player-details.component.html",
  styleUrls: ["./player-details.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class ContestPlayerDetailsComponent implements OnInit {
  public userId;
  public userData;
  public userLatestScore;
  public items;
  public scoreList;
  public totalRecords = 0;
  loading: boolean;
  paginationOption;
  profilepic;
  fullName;
  userid;
  age;
  gender;
  public matchTypeId;
  public agegroupId;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public matchAgeQuery: string;
  public cityname;
  public statename;
  public userLatestRank;
  pageNumberFirst: any;
  pageLimitFirst: number;
  constructor(private tournamentsService: TournamentsService, private userService: UserService, private activeRoute: ActivatedRoute, private route: Router, private subscribeService: SubscribeService) { }

  ngOnInit(): void {
    this.userId = this.activeRoute.snapshot.paramMap.get('id');
    // this.matchTypeId = this.activeRoute.snapshot.paramMap.get('matchTypeId'); 
    // this.agegroupId = this.activeRoute.snapshot.paramMap.get('agegroupId');
    this.activeRoute.queryParams
      .subscribe(params => {
        this.matchTypeId = params.filterByMatchId;
        this.agegroupId = params.filterByAgegroupId;
        if(params['page']) {
          this.pageNumberFirst = params['page'];
        } else {
          this.pageNumberFirst = 1;
        }
        if(params['limit']) {
          this.pageLimitFirst = +params['limit'];
        } else {
          this.pageLimitFirst = 10;
        }
      }
      );
    this.subscribeService._playerRankingDetails.subscribe((res) => {
      if (res) {
        this.matchAgeQuery = res;        
      }
    });
    this.paginationOption = environment.pagination;
    this.getUserDetails();
    //this.getUserLatestScore();
  }

  onUserScorePageChange(event) {
    let pagenumber = 1;
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    this.route.navigate([], {
      relativeTo: this.activeRoute,
      queryParams: { page: pagenumber,limit:rows },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  getUserLatestScore() {
    this.tournamentsService.tournamentPlayerLatestscore(this.userId).subscribe(res => {
      console.log(res);
      //this.userLatestScore = res['totalRank']['data'][0]['playerRanking']; //res['playerRanking'];
    });
  }
  getUserDetails() {
    this.userService.getUserWithoutAuth(this.userId).subscribe(res => {
      this.userData = res;
      this.profilepic = this.userData.profilepic;
      this.fullName = this.userData.fullName;
      this.profilepic = this.userData.profilepic;
      this.userid = this.userData.id;
      this.age = this.userData.age;
      this.gender = this.userData.gender;
      this.cityname = this.userData.cityname;
      this.statename = this.userData.statename;


    });
  }
  getUserScore(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;

    //let query = "filterByDisable=false&filterByPublishStatus=true&"+this.matchAgeQuery;//filterByMatchId=" + this.matchTypeId + "&filterByAgegroupId=" + this.agegroupId;
    let query = "filterByDisable=false&filterByPublishStatus=true";
    if(this.matchAgeQuery != undefined){
      query +="&"+this.matchAgeQuery;
    }
    let pagenumber = 1;
    let params = "";
    let rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    
    this.tournamentsService.userContestPlayerscore(this.userId, query).subscribe((res) => {
      this.items = res;
      //this.userData = res['userData'];
      this.userLatestScore = res['totalRank'];
      this.userLatestRank = res['items'][0]['totalPoints'];
      this.scoreList = res['items'];
      this.totalRecords = res["totalCount"];
      // this.totalRecords = res["totalCount"];
      //this.tournamentname = res.name;

    });
  }

  onclickTournamentdetails(id) {
    this.route.navigate(["tournaments/factsheet/" + id]);
  }

}
